import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AtomicButton from '../../atomic/button/Button';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import zipcodeBusinessStats from '../../utils/zipcode.business.stats';
import { verbiage } from './../../utils/constants';
import { isMobile, isDesktop, isIpad } from '../../utils/ScreenSizeHelper';
import GoogleMap from '../../composed/googlemap/GoogleMap';

const CongratsStep = () => {
  const navigate = useNavigate();
  const { zipcodeInfo, setShowPricePlan } = useContext(GlobalStateDataContext);
  const { managing_branch_name } = zipcodeInfo;
  const { CONGRATS_MSG } = verbiage;

  useEffect(() => {
    setShowPricePlan(false);
  }, []);

  const handleSubmit = async (e) => {
    setShowPricePlan(true);
    navigate('/priceplan');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        height: 'auto',
        borderRadius: '10px',
        boxShadow: '0 3px 6px 0 #bdbdbdff',
        padding: '40px',
        border: '4px solid hwb(23 16% 0%)',
        marginTop: '40px',
      }}
    >
      <div
        style={{
          marginBottom: '10px',
          color: '#3F3F6E',
          fontSize: isIpad ? '22px' : '26px',
          fontWeight: '700',
        }}
      >
        {' '}
        Let’s Get Started!
      </div>
      <div
        style={{
          marginBottom: '20px',
          color: '#3F3F6E',
          fontSize: '14px',
          fontFamily: 'Inter Light',
          fontWeight: '400',
          width: '400px',
          letterSpacing: '0.5px',
        }}
      >
        {CONGRATS_MSG}
      </div>
      <div
        style={{
          marginBottom: '05px',
          color: '#3F3F6E',
          fontSize: '14px',
          fontFamily: 'Inter Bold',
          letterSpacing: '0.5px',
        }}
      >
        Exclusive Visibility and Demographic Informations{' '}
      </div>

      {/* Get bellow stats from this method {zipcodeBusinessStats(managing_branch_name).population}*/}
      <div
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          color: '#3F3F6E',
          fontSize: '14px',
          fontFamily: 'Inter Light',
          width: '400px',
          textAlign: 'justify',
          letterSpacing: '0.5px',
        }}
      >
        Your store will be visible within a 10–15 mile radius — covering around{' '}
        <span style={{ fontFamily: 'Inter Bold' }}> 47 ZIP codes</span> and a population of over{' '}
        <span style={{ fontFamily: 'Inter Bold' }}> 1.8 million. </span> This gives you a huge
        opportunity to tap into a strong local audience and benefit from platform fees as low as 0%.
      </div>

      <AtomicButton
        label="Let's signup"
        handleSubmit={handleSubmit}
        style={{ backgroundColor: '#181436', width: '450px' }}
        loading={false}
        disabled={false}
      />
      {
        <div
          style={{ width: '450px', height: '400px', backgroundColor: 'blue', overflow: 'hidden' }}
        >
          <GoogleMap />{' '}
        </div>
      }
    </div>
  );
};

export default CongratsStep;
